import { useMemo, useState } from "react";

import isNil from "lodash/isNil";

import { isArray, size } from "lodash";
import RffFileUploadField from "../../components/finalForm/inputs/RffFileUploadField";
import RffFullPageFormStepper from "../../components/finalForm/RffFullPageFormStepper";
import RffGroup from "../../components/finalForm/shared/RffGroup";
import { useBorrowerSubmissionsHook } from "../../hooks/useBorrowerSubmissionsHook";
import LoanQuickAppStepOneBorrowerDetails from "./steps/LoanQuickAppStepOneBorrowerDetails";
import LoanQuickAppStepThreeInvestorProfile from "./steps/LoanQuickAppStepThreeInvestorProfile";
import LoanQuickAppStepTwoPropertyDetails from "./steps/LoanQuickAppStepTwoPropertyDetails";

// Q: is it okay that im adding "Fix and Rent" to selectOptionsLoanProductType ?
const LoanQuickApplicationFormWizardScreen = ({ initialValues }) => {
  const [success, setSuccess] = useState(false);
  const {
    loading,

    createQuickApp,
    createQuickAppWithFileUploads,
  } = useBorrowerSubmissionsHook();

  const [includesBroker, setIncludesBroker] = useState(false);
  // Get initial values from query params or props
  const init = useMemo(() => {
    if (!isNil(initialValues)) {
      return initialValues;
    }

    // Default
    return {};
    // return { subjectProperties: [{}] };
  }, [initialValues]);

  const onFormSubmit = (originalData) => {
    let data = { ...originalData };

    if (data?.loanProductType === "Fix and Rent") {
      data.loanProductType = "Fix and Flip";
      data.productSelectionStrategy = "Fix and Rent";
      data.exitStrategy = "(Automated) Hold as Rental";
    }

    if (isArray(data?.uploadMetadata) && size(data?.uploadMetadata) >= 1) {
      createQuickAppWithFileUploads({
        data: data,
        onSuccessFn: (d) => {
          setSuccess(true);
        },
      });
    } else {
      createQuickApp({
        data: data,
        onSuccessFn: (d) => {
          setSuccess(true);
        },
      });
    }
  };

  const basicInfoTitle = useMemo(() => {
    if (includesBroker) {
      return "Borrower & Broker Details";
    }
    return "Borrower Details";
  }, [includesBroker]);

  return (
    <>
      <RffFullPageFormStepper
        className={"required"}
        loading={loading}
        success={success}
        // formSpy
        initialValues={init}
        onSubmit={onFormSubmit}
        formTitle={"Loan Quick Application"}
        formDescription="Please provide the required information below. Let's start by learning a little more about you."
        finalStepLabel="Submit"
        sx={{
          ".input-wrapper-root.required": {
            border: "1px solid red",
          },
        }}
      >
        <LoanQuickAppStepOneBorrowerDetails
          stepName={basicInfoTitle}
          setIncludesBroker={setIncludesBroker}
        />
        <LoanQuickAppStepTwoPropertyDetails stepName="Property Details" />
        <LoanQuickAppStepThreeInvestorProfile stepName="Investor Profile" />

        <UploadFilesPage stepName="Upload Related Files" />
      </RffFullPageFormStepper>
    </>
  );
};

const UploadFilesPage = () => {
  return (
    <>
      <RffGroup titleType="h2" title="Related File Uploads">
        <RffFileUploadField
          label="Upload any files related to this loan application"
          // required
          allowRename
          // docGroup={"Borrower Documents"}
          // docType={"Photo Identification"}
          // helperText="Please ensure to upload both front and back of identification"
        />
      </RffGroup>
    </>
  );
};

export default LoanQuickApplicationFormWizardScreen;
